<template>    
    <BaseModal
        :id="'static-facility-selection'"
        :title="title"
        :message="message"
        :size="'md'"
    >
        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb"/>
        </template>
        <template v-slot:content>
            <form class="p-0" @submit.prevent="form_submit_local()">
                <div class="alert alert-primary mt-3" role="alert" v-if="countdown_enabled">
                    You will be redirected to the only dashboard's facility of this corporation in <b>{{ countdown }}</b> <a href="JavaScript:void(0);" @click="countdown_enabled = false">Cancel</a>
                </div>
                <div class="row justify-content-center">
                    <div class="p-0 formdynamic__item col-md-7" :style="`margin-top:20px`">
                        <div class="formdynamic__item__field" id="1">
                            <label style="display: block" v-html="`Corporation:`" class="modal-label mb-1" for="1"/>
                            <select
                                style="max-width: 100%"
                                :disabled="(user && user.super_admin_id) ? false : true"
                                class="input-field custom-select"
                                v-model="corporation_id">
                                <option :value="null" :disabled="(user && user.super_admin_id) ? false : true" v-html="(user && user.super_admin_id) ? 'Select an option' : 'Not assigned'"/>
                                <option v-for="(value, i) in corporations" :key="i" :value="value.id" v-html="value.name"/>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="row justify-content-center">
                    <div class="p-0 formdynamic__item col-md-7" :style="`margin-top:10px`">
                        <div class="formdynamic__item__field" id="1">
                            <label style="display: block" v-html="`Facility: <b style='color:red;'>*</b>`" class="modal-label" for="1"/>
                            <select
                                required
                                style="max-width: 100%"
                                class="input-field custom-select"
                                v-model="associate_index">
                                <option :value="''" :disabled="true" v-html="'Select an option'"/>
                                <option v-for="(value, i) in associates_filtered" :key="i" :value="i" v-html="value.facility_name"/>
                            </select>
                        </div>
                    </div>
                </div>
                <CentralLiteButtons :save_text="'Login'"/> 
            </form>
        </template>
    </BaseModal>
</template>

<script>

import Breadcrumb           from    '@/components/BreadcrumbComponent/Breadcrumb'
import BaseModal            from    '@/components/BaseModal'
import CentralLiteButtons   from    '@/components/CentralLiteButtons'
import Resources            from './Resources'

export default {

    name:   'FacilitySelection',

    props: [
        'title',
        'associates',
        'corporations',
        'user'
    ],

    components:{
        Breadcrumb,
        BaseModal,
        CentralLiteButtons,
    },

    data(){
        return{
            associate_index: '',
            breadcrumb: Resources.breadcrumb,
            message: '',
            corporation_id: '',
            countdown_enabled: false,
            countdown: 0,
            intervalFunc: null
        }
    },

   
    watch:
    {
        

        associates:
        {
            handler(val)
            {
                let msg1 = `We found your user in ${val.length} ${(val.length > 1 || val.length == 0)? 'facilities' : 'facility'}, please select the facility you wish to login to`
                let msg2 = 'As a super admin you are able to log in to any facility'
                this.message = (this.user.super_admin_id) ? msg2 : msg1

            },
            deep: true
        },

        user:
        {
            handler(val)
            {
                this.corporation_id = val.corporation_id;
            },
            deep: true
        },

        corporation_id:
        {
            handler()
            {
                this.associate_index = '';

                let associates_found = this.associates_filtered

                if(associates_found && associates_found.length == 1)
                {
                    this.startCountDown()
                    this.countdown_enabled = true
                }
                else
                {
                    this.countdown = 0
                    this.countdown_enabled = false
                }
                
            }
        }

    },
   
    methods:
    {
        form_submit_local()
        {
            this.$emit('login', {associate: this.associates_filtered[this.associate_index]})
        },

        startCountDown()
        {
            this.countdown = 4

            clearInterval(this.intervalFunc)

             this.intervalFunc = setInterval(() => 
             {

                this.countdown -= 1

                if (this.countdown <= 0)
                {
                    clearInterval(this.intervalFunc)  

                    if(this.countdown_enabled && this.associates_filtered && this.associates_filtered.length == 1)
                    {
                        this.$emit('login', {associate: this.associates_filtered[0]})
                    }
                }
            }, 1000);
        },

    },

    computed: {
        associates_filtered()
        {
            if(this.corporation_id)
            {
                return this.associates.filter(item => item.corporation_id == this.corporation_id)
            }

            return this.associates;
        }
    },

    mounted()
    {
        this.startCountDown()
    }

    
}
</script>